const editorTypes = {
    READONLY: "readonly",
}

export default editorTypes;